// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3WVI7","errorLogs":"styles_errorLogs__2GiqR"};